import PageTitle from './PageTitle';

export default PageTitle;



// WEBPACK FOOTER //
// ./src/components/PageTitle/index.js